import * as c from 'constants/actionTypes/settings';
import {
  updatePreview,
} from '../actions';

const defaultState = {
  isFetched: false,
  hexRegEx: /^#([A-Fa-f0-9]{6})$/,

  isFetching: false,
  isUpdatingSearch: false,
  isUpdatingRecs: false,

  describes: {
    isFetching: false,
  },

  platformSettings: {
    isFetching: false,
  },

  searchVisible: { isFetching: false, value: true },
  recsVisible: { isFetching: false, value: true },

  alerts: {
    isFetching: true,
    data: [],
    actions: {
      COMPILE_BUNDLE: { id: 'COMPILE_BUNDLE', titleKey: 'alerts.title.note', status: 'info', messageKey: 'alerts.compile.message' },
      REBUILD_INDEX: { id: 'REBUILD_INDEX', titleKey: 'alerts.title.note', status: 'info', messageKey: 'alerts.rebuildIndex.message' },
      SING_IN_FAILED: { id: 'SING_IN_FAILED', titleKey: 'alerts.title.error', status: 'warning', messageKey: 'alerts.signInFailed.message' },
      PASSWORD_RESET_FAILED: { id: 'PASSWORD_RESET_FAILED', titleKey: 'alerts.title.error', status: 'warning', messageKey: 'alerts.passwordResetFailed.message' },
      PASSWORD_RESET: { id: 'RESET_PASSWORD', titleKey: 'alerts.title.note', status: 'info', messageKey: 'alerts.passwordReset.message' },
      PASSWORDS_NOT_MATCHED: { id: 'PASSWORDS_NOT_MATCHED', titleKey: 'alerts.title.note', status: 'warning', messageKey: 'alerts.passwordsNotMatched.message' },
      PASSWORD_TOO_SHORT: { id: 'PASSWORD_TOO_SHORT', titleKey: 'alerts.title.note', status: 'warning', messageKey: 'alerts.passwordTooShort.message' },
      PASSWORD_UPDATED_SUCCESSFULLY: { id: 'PASSWORD_UPDATED_SUCCESSFULLY', titleKey: 'alerts.title.note', status: 'info', messageKey: 'alerts.passwordUpdated.message' },
      PASSWORD_SUBMIT_TOKEN_NOT_FOUND: { id: 'PASSWORD_SUBMIT_TOKEN_NOT_FOUND', titleKey: 'alerts.title.note', status: 'info', messageKey: 'alerts.passwordTokenInvalid.message' },
    },
  },
  forDiff: { searchVisible: true, recsVisible: true },
  recs: {},
  search: {},
};

export default (state = defaultState, { type, payload }) => {
  const stateCopy = { ...state };
  switch (type) {
    case c.GET_ALL_SETTINGS: {
      const tenantChanged = state.shopId !== payload;
      return {
        ...state,
        ...(tenantChanged ? {
          search: {},
          recs: {},
          searchEnabled: false,
          searchVisible: { isFetching: false, value: false },
          recsVisible: { isFetching: false, value: false },
        } : {}),
        shopId: payload,
        isFetched: false,
        isFetching: true,
      };
    }

    case c.GET_ALL_SETTINGS_COMPLETE:
      const { search } = payload;

      return {
        ...state,
        ...payload,
        preview: search,
        isFetching: false,
        isFetched: true,
        searchVisible: {
          ...state.searchVisible,
          value: payload.searchVisible,
        },
        recsVisible: {
          ...state.recsVisible,
          value: payload.recsVisible,
        },
      };

    case c.GET_ALL_SETTINGS_FAILED:
      // Gateway unavailable (bridge-only mode or network error). Unblock
      // downstream consumers that gate on isFetched — they will degrade
      // gracefully using plugin-lane data instead of gateway data.
      return {
        ...state,
        isFetching: false,
        isFetched: true,
      };

    case c.UPDATE_RECS_VISIBLE:
      stateCopy.recsVisible.value = payload;
      return stateCopy;

    case c.UPDATE_SEARCH_VISIBLE:
      stateCopy.searchVisible.value = payload;
      return stateCopy;

    case updatePreview().type:
      stateCopy.isPreview = payload;
      return stateCopy;

    case c.GET_DESCRIBES_COMPLETE:
      return {
        ...state,
        describes: {
          isFetching: false,
          isFetched: true,
          ...payload,
        },
      };

    case c.GET_PLATFORM_COMPLETE:
      return {
        ...state,
        platformSettings: {
          isFetching: false,
          isFetched: true,
          ...payload,
        },
      };

      /**
       * Recs Settings
       */
    case c.CHANGE_RECS_THEME_SETTING:
      return {
        ...state,
        recs: {
          ...state.recs,
          theme: {
            ...state.recs.theme,
            [payload.key]: payload.value,
          },
        },
      };

    case c.CHANGE_RECS_ONBOARDING:
      return {
        ...state,
        recs: {
          ...state.recs,
          onboarding: {
            ...state.recs.onboarding,
            ...payload,
          },
        },
      };

    /**
       * Search Settings
       */
    case c.CHANGE_SEARCH_ONBOARDING:
      return {
        ...state,
        search: {
          ...state.search,
          onboarding: {
            ...state.search.onboarding,
            ...payload,
          },
        },
      };

    case c.CHANGE_SEARCH_GENERAL_SETTING:
      return {
        ...state,
        search: {
          ...state.search,
          general: {
            ...state.search.general,
            [payload.key]: payload.value,
          },
        },
      };

    case c.CHANGE_SEARCH_BOX_SETTING:
      return {
        ...state,
        search: {
          ...state.search,
          searchBox: {
            ...state.search.searchBox,
            [payload.key]: payload.value,
          },
        },
      };

    case c.CHANGE_SEARCH_RESULT_SETTING:
      return {
        ...state,
        search: {
          ...state.search,
          searchResultPage: {
            ...state.search.searchResultPage,
            [payload.key]: payload.value,
          },
        },
      };

    case c.CHANGE_SEARCH_FACETS_SETTING:
      return {
        ...state,
        search: {
          ...state.search,
          facets: {
            ...state.search.facets,
            [payload.key]: payload.value,
          },
        },
      };

    case c.CHANGE_SEARCH_THEME_SETTING:
      return {
        ...state,
        search: {
          ...state.search,
          theme: {
            ...state.search.theme,
            [payload.key]: payload.value,
          },
        },
      };

      /**
       * Reset settings
       */

    case c.RESET_SEARCH_SETTINGS_TO_DEFAULT:
      return {
        ...state,
        search: state.forDiff.search,
        searchVisible: {
          ...state.searchVisible,
          value: state.forDiff.searchVisible,
        },
      };

    case c.RESET_RECS_SETTINGS_TO_DEFAULT:
      return {
        ...state,
        recs: state.forDiff.recs,
        recsVisible: {
          ...state.recsVisible,
          value: state.forDiff.recsVisible,
        },
      };

    case c.RESET_SETTINGS_TO_DEFAULT:
      return {
        ...state,
        recs: {
          ...state.recs,
          theme: state.forDiff.recs.theme,
        },
        fields: {
          ...state.fields,
          data: state.fields.examplar,
        },
        recsVisible: {
          ...state.recsVisible,
          value: state.forDiff.recsVisible,
        },
        searchVisible: {
          ...state.searchVisible,
          value: state.forDiff.searchVisible,
        },
      };

      /**
       * Save settings flags
       */

    case c.SAVE_RECS_SETTINGS:
      return {
        ...state,
        isUpdatingRecs: true,
      };

    case c.SAVE_RECS_SETTINGS_COMPLETED:
    case c.SAVE_RECS_SETTINGS_FAILED:
      return {
        ...state,
        isUpdatingRecs: false,
      };

    case c.SAVE_SEARCH_SETTINGS:
      return {
        ...state,
        isUpdatingSearch: true,
      };

    case c.SAVE_SEARCH_SETTINGS_COMPLETED:
    case c.SAVE_SEARCH_SETTINGS_FAILED:
      return {
        ...state,
        isUpdatingSearch: false,
      };

      /**
       * Alert banners
       */
    case c.REWRITE_ALERT_BANNERS:
      return {
        ...state,
        alerts: {
          ...state.alerts,
          isFetching: false,
          data: payload,
        },
      };

    default:
      return state;
  }
};
